module.exports = __webpack_public_path__ + "static/finding-flow-9237c049408bc9bfe811d3e3030f02f1.jpg";